import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Constants } from '../../utils/constants';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-azure-batch-link-cell-renderer',
  templateUrl: './azure-batch-link-cell-renderer.component.html',
  styleUrls: ['./azure-batch-link-cell-renderer.component.css']
})
export class AzureBatchLinkCellRendererComponent implements ICellRendererAngularComp {
  private params: any;
  status: string | undefined;
  subscription: string | undefined;
  environment: string | undefined;
  azureBatchAccountName: string | undefined;
  jobId: string | undefined;
  azureBatchLink: string | undefined;
  modelVersion: string | undefined;

  agInit(params: ICellRendererParams<any, any, any>): void {
    this.params = params;
    this.status = params.value;
    this.modelVersion = params.data?.ModelVersion;
    this.getAzureBatchLink();
  }

  getAzureBatchLink() {
    if (this.params?.data) {
      const name: string = this.params.data.name;
      const lastOutputFolder: string = this.params.data.lastOutputFolder;
      this.jobId = `${this.getPoolModelName(name)}_${lastOutputFolder}`;
      this.azureBatchLink = `https://portal.azure.com/?pwa=1#view/Microsoft_Azure_Batch/JobMenuBlade/~/tasks/batchAccountId/%2Fsubscriptions%2${environment.azureBatchsubscription}%2FresourceGroups%2F${environment.researchEnvironment}%2Fproviders%2FMicrosoft.Batch%2FbatchAccounts%2F${environment.azureBatchAccountName}/jobId/${this.jobId}`;
    }
  }

  getPoolModelName(name: string): string {
    const poolModel = Constants.POOL_MODELS_NAMES.find(model => model.key === name);
    if (poolModel)
      return poolModel.label;
    return name;
  }

  refresh(params: ICellRendererParams<any, any, any>): boolean {
    throw new Error('Method not implemented.');
  }

  showLink(): boolean {
    return this.status === Constants.PROJECT_STATUS.IN_PROGRESS && Constants.MODELS_RUN_AZURE_BATCH.includes(this.params?.data?.name);
  }

}
